
export default {
  name: 'SectionStage',
  components: {},
  props: {
    data: {
      type: Object,
      required: true
    },
    contact: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // icons: [],
      logoLoading: true,
      collapsedContent: false,
      firstBreadcrumbPath: {
        de: {
          text: 'Technologie',
          to: { path: '/technologie' }
        },
        en: {
          text: 'Technology',
          to: { path: '/technology' }
        }
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    breadcrumb() {
      return [
        this.firstBreadcrumbPath[this.language],
        {
          text: this.data.generic.headline,
          active: true
        }
      ]
    }
  },
  mounted() {
    // for (let index = 0; index < 4; index++) {
    //   const path = `/homepage/technology/${this.$route.params.slug}/img/icon-${index}.svg`
    //   fetch(path, { method: 'HEAD' })
    //     .then((res) => {
    //       if (res.ok) {
    //         this.icons.push(path)
    //       }
    //       console.clear()
    //     })
    //     .catch(() => {
    //       console.clear()
    //     })
    // }
  },
  created() {},
  methods: {}
}
